module.exports = __webpack_public_path__ + "static/media/productos_home_naturales.295be1d3.jpg";